import React, { FC } from "react";
import clsx from "clsx";
import { useTariffOptions } from "./useTariffOptions";
import cls from "./styles.module.scss";

export const TariffOptions: FC = () => {
  const { modes, selectedTariff, selectTariff } = useTariffOptions();

  return (
    <div className={cls.items}>
      {modes.map(({ id, label, Icon }) => {
        const active = id === selectedTariff;

        return (
          <button
            key={id}
            type="button"
            onClick={() => selectTariff(id)}
            className={clsx(cls.item, active && cls.active)}
            aria-pressed={active}
          >
            <Icon active={active} />
            <span className={cls.label}>{label}</span>
          </button>
        );
      })}
    </div>
  );
};
